export default Object.freeze({
  Incomplete: 1,
  Ready: 2,
});
